var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31105 5.13832L7.67045 0.778959H5.82042V0H8.61072C8.82588 0 9 0.174515 9 0.389281V3.17955H8.22103V1.32954L3.86163 5.6889L3.31105 5.13832ZM8.11559 4.94229H7.33663V7.67523C7.33663 7.97486 7.08998 8.2211 6.79075 8.2211H1.32481C1.02518 8.2211 0.778936 7.97486 0.778936 7.67523V2.20934C0.778936 1.90971 1.02518 1.66347 1.32481 1.66347H4.05778V0.884511H1.32481C0.595259 0.884511 0 1.47978 0 2.20931V7.6752C0 8.40475 0.595677 9 1.32481 9H6.79075C7.5203 9 8.11556 8.40473 8.11556 7.6752L8.11596 4.94226L8.11559 4.94229Z",
    fill: "#362A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b18dd6b9c10d612d5a866e85d78fdf34.svg";
export { ForwardRef as ReactComponent };